import React from 'react';

const features = [
  {
    title: "Professional Services",
    description: "Expert repair services for all your mobile devices",
    icon: "fa-solid fa-tools",
    link: "/services"
  },
  {
    title: "Telecom Solutions",
    description: "Best mobile plans and telecom services",
    icon: "fa-solid fa-tower-cell",
    link: "/telecom"
  },
  {
    title: "24/7 Support",
    description: "Round the clock customer support",
    icon: "fa-solid fa-headset",
    link: "/contact"
  },
  {
    title: "Fast Booking",
    description: "Quick and easy service booking",
    icon: "fa-solid fa-calendar-check",
    link: "/booking"
  }
];

const telecomProviders = [
  {
    name: "Koodo",
    logo: "/images/koodo-logo.png",
    description: "Flexible plans with no hidden fees",
    features: ["Customizable Plans", "Tab Payment System", "Shock-Free Data", "Canada-Wide Coverage"]
  }
];

const TelecomFeatures = () => {
  return (
    <section id="telecom" className="py-12">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Our Telecom Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">We partner with leading telecom providers to offer you the best mobile plans and services</p>
        </div>
        
        {/* Feature Cards */}
        <section className="py-16 bg-gray-50 rounded-xl mb-16">
          <div className="container">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {features.map((feature) => (
                <div key={feature.title} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                  <div className="text-primary text-3xl mb-4">
                    <i className={feature.icon}></i>
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                  <p className="text-gray-600 mb-4">{feature.description}</p>
                  <a href={feature.link} className="text-primary hover:text-primary/90 transition-colors">Learn More →</a>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        {/* Telecom Providers */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h2 className="section-title flex items-center gap-2 justify-center text-2xl font-semibold">
              <i className="fa-solid fa-tower-cell text-primary"></i>
              Telecom Providers
            </h2>
            <p className="text-gray-600 mt-2">Connect with the best telecom providers for your mobile needs</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {telecomProviders.map((provider) => (
              <div key={provider.name} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
                <div className="telecom-logo mb-4 h-16 flex items-center justify-center">
                  <img src={provider.logo} alt={provider.name} className="h-12 object-contain" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{provider.name}</h3>
                <p className="text-gray-600 mb-4">{provider.description}</p>
                <ul className="space-y-2 mb-4 flex-grow">
                  {provider.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2">
                      <i className="fa-solid fa-check text-primary"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a href="/telecom" className="text-primary hover:text-primary/90 transition-colors mt-auto">View Plans →</a>
              </div>
            ))}
          </div>
        </div>
        
        {/* CTA Section */}
        <div className="bg-primary/10 p-8 rounded-xl text-center">
          <h3 className="text-2xl font-semibold mb-4">Need help choosing the right plan?</h3>
          <p className="text-gray-600 mb-6">Our telecom experts can help you find the perfect plan for your needs and budget</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="/telecom" className="inline-block bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-primary/90 transition-all">
              View All Plans
            </a>
            <a href="/contact" className="inline-block bg-white border border-primary text-primary px-8 py-3 rounded-md font-medium hover:bg-gray-50 transition-all">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TelecomFeatures;
